import React from 'react';
import { NavLink } from 'react-router-dom';
import { Typography, Image } from 'lib/components';
import { SideNavItem } from 'lib/components/types';
import classes from './index.module.scss';

/**
 * Props interface for the SideNavLink component
 * Extends SideNavItem but omits role and permission properties
 */
interface Props extends Omit<SideNavItem, 'roles' | 'permission'> {}

/**
 * SideNavLink component
 * Renders a single navigation link in the side navigation
 * Includes an icon and text with active state styling
 *
 * @param {Props} props - Component props
 * @returns {JSX.Element} - Rendered component
 */
const SideNavLink = ({ to, icon, title }: Props) => (
	<NavLink key={title} className={classes['sideNav-item']} activeClassName={classes['sideNav-item-active']} to={to}>
		{/* Navigation item icon */}
		<Image className={classes['sideNav-item-icon']} src={icon} alt={title + ' icon'} />
		{/* Navigation item text */}
		<Typography className={classes['sideNav-item-title']} variant="subheading1">
			{title}
		</Typography>
	</NavLink>
);

export default SideNavLink;
